import { EventEmitter, Injectable } from '@angular/core';
import { VehicleListValue } from '../walk-in/models/vehicle-list-value.model';
import { UntypedFormGroup } from '@angular/forms';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor() { 
   
  }
  public source = new EventEmitter<boolean>();
  public runner = new EventEmitter<boolean>();
  public vrm = new EventEmitter<string>();
  public isRelated = new EventEmitter<boolean>();
  public selectedVehicle = new EventEmitter<VehicleListValue>();
  public selectedPlate = new EventEmitter<string>();
  public isManualLookup = false;
  internalNavigation: boolean;

  getItem(key) {
    if (localStorage.getItem(key)) {
      return localStorage.getItem(key);
    }
    return null;
  }

  setDateItem(key) {
    localStorage.setItem(key, new Date().toISOString());
  }

  setIsManualLookup(value: boolean) {
    this.isManualLookup = value;
  }

  getIsManualLookup(): boolean {
    return this.isManualLookup;
  }

  checkEmail(form: UntypedFormGroup) {
    return (form.get('emailAddress').errors?.required && form.get('emailAddress').dirty) || form.get('emailAddress').errors?.validateRegex || form.get('emailAddress').touched;
  }

  markAsInternal() {
    this.internalNavigation = true;
  }

  reset() {
    this.internalNavigation = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getSessionStorageItem<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeSessionStorageItem(key: string) {
    sessionStorage.removeItem(key);
  }
}
